export default __webpack_public_path__ + "static/media/02.b470ee75.jpg";